
<template>
  <!--投诉原因-->
  <div>
    <!--面包屑-->
    <div class='table-bread'>
      <span class="title">当前位置：</span>
      <a-breadcrumb>
        <span slot="separator" :style="{color: 'red'}">></span>
        <template  v-for="(item, index) of levelList">
          <a-breadcrumb-item @click.native="clickBread(item, index)" :key="index">
            <span v-if="index === levelList.length - 1">{{item.name}}</span>
            <span :style="{ cursor: 'pointer' }" v-else type="link">{{item.name}}</span>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
    </div>

    <x-tabula
      apiOrigin="PHP"
      ref="table"
      @resetSearch="resetSearch"
      :dataSource="dataSource"
      :rowOptLen="4"
      rowKey="chat_category_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'complainReason',
  data () {
    return {
      levelList: [{ id: '', name: '首页' }],
      searchList: [
        { props: ['keywords'], placeholder: '投诉原因', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '应用位置', options: [], inputType: 'select' }
      ],
      searchParams: {
        keywords: undefined,
        type: undefined,
        parent_id: undefined
      },
      tableOptList: [{ text: '新增', icon: 'plus', permi: ['neighbour:complainReason:add'] }],
      rowOptList: [
        {
          text: '查看子类',
          handle: (row) => this.showSubCategory(row),
          rowOptDisHandle: row => row.can_see_child === 0,
          permi: ['neighbour:complainReason:showChildren']
        },
        {
          text: '添加子类',
          handle: (row) => this.toAddChild(row),
          rowOptDisHandle: row => row.can_add_child === 0,
          permi: ['neighbour:complainReason:addChildren']
        },
        {text: '修改', handle: (row) => this.$refs.table.toEdit(row), permi: ['neighbour:complainReason:edit']},
        {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['neighbour:complainReason:delete']}
      ],
      columns: [
        { title: '投诉原因', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用位置', dataIndex: 'type_desc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/chat/category/complaint',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addReason',
        addTitle: '新增投诉',
        editTitle: '修改投诉'
      },
      deleteParam: {
        url: '/chat/category/complaint',
        param: { pk_key: '', pk_val: 'chat_category_id' },
        title: '投诉原因',
        key: 'title'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this._get({
        url: '/chat/category/complaint_select',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.type;
      });
    },
    /** 重置搜索 */
    resetSearch () {
      this.levelList.splice(1, this.levelList.length - 1);
    },
    /* 点击面包屑 */
    clickBread (item, index) {
      let len = this.levelList.length;
      if (index === len - 1) {
        return false;
      } else {
        this.levelList.splice(index + 1, len - (index + 1));
        this.resetData(this.searchParams);
        this.searchParams.parent_id = item.id;
        this.$refs.table.getTableList();
      }
    },
    /* 查看下级 */
    showSubCategory (row) {
      let everySame = this.levelList.every(ele => ele.id !== row.category_id);
      if (everySame) {
        this.levelList.push({
          id: row.chat_category_id,
          name: row.title
        });
        this.resetData(this.searchParams);
        this.searchParams.parent_id = row.chat_category_id;
        this.$refs.table.getTableList();
      }
    },

    /* 进入添加子类 */
    toAddChild (row) {
      let idArr;
      if (row.parent_id.length) {
        idArr = [...row.parent_id, row.chat_category_id];
      } else {
        idArr = [row.chat_category_id];
      }
      this.$router.push({
        name: 'addReason',
        query: {
          parentId: idArr,
          type: row.type,
          title: '添加子类'
        }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
